import { render } from "./Manage.vue?vue&type=template&id=40e83924&ts=true"
import script from "./Manage.vue?vue&type=script&lang=ts"
export * from "./Manage.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__